import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, HashRouter, Route, Switch } from "react-router-dom";
import "./config/util";
import { AlertContextProvider } from "./contexts/AlertContext";

//ie11 react
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { LoadingContextProvider } from "./contexts/LoadingContext";
import { DupLoginContextProvider } from "./contexts/DupLoginContext";
import { pages } from "./constants/PagePaths";
import VideoMain from "./pages/video/components/main/VideoMain";
import LectureList from "./pages/video/components/lectureList/LectureList";
import LectureContent from "./pages/video/components/lectureContent/LectureContent";
import VideoLogin from "./pages/video/components/login/VideoLogin";
import VideoSignUp from "./pages/video/components/videoSignUp/VideoSignUp";
import VideoMyPage from "./pages/video/components/videoMyPage/VideoMyPage";
import MyLecture from "./pages/video/components/myLecture/MyLecture";
import Notice from "./pages/video/components/notice/Notice";
import VideoPayment from "./pages/video/components/payment/VideoPayment";
import Video from "./pages/video/components/video/Video";
import VideoFindAccount from "./pages/video/components/findAccount/VideoFindAccount";
import PaymentContainer from "./pages/payment/PaymentContainer";

// 하위 경로 배포(광해 데모 dev.ddusul.com/komir/)는 서버 폴백이 없어 해시 라우팅으로 빌드한다(REACT_APP_HASH_ROUTER=1).
const RouterImpl = process.env.REACT_APP_HASH_ROUTER === "1" ? HashRouter : BrowserRouter;

// ── 캐시/배포 안전망 ──
// 사용자 브라우저가 옛 index.html이나 옛 chunk를 캐싱한 상태로 새 빌드 배포되면
// "Loading chunk N failed" 같은 에러로 화면이 멈출 수 있다.
// 그 에러를 감지하면 한 번만 강제 새로고침해서 새 index.html + 새 chunk를 받게 한다.
const CHUNK_RELOAD_FLAG = "__chunk_reloaded_at__";
const CHUNK_RELOAD_COOLDOWN = 60 * 1000; // 1분 — 무한 reload 루프 방지

function isChunkLoadError(msg) {
  if (!msg) return false;
  const s = String(msg);
  return (
    s.includes("Loading chunk") ||
    s.includes("Loading CSS chunk") ||
    s.includes("ChunkLoadError") ||
    /chunk \d+ failed/i.test(s)
  );
}

function maybeReloadOnChunkError(msg) {
  if (!isChunkLoadError(msg)) return;
  try {
    const last = +(sessionStorage.getItem(CHUNK_RELOAD_FLAG) || 0);
    if (Date.now() - last < CHUNK_RELOAD_COOLDOWN) return; // 최근 reload했으면 무한 루프 방지
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, String(Date.now()));
  } catch (e) {
    // sessionStorage 차단된 환경 — reload 한 번은 시도
  }
  // 캐시 무효화 위해 query string 추가
  const url = new URL(window.location.href);
  url.searchParams.set("_r", Date.now().toString(36));
  window.location.replace(url.toString());
}

window.addEventListener("error", (e) => {
  maybeReloadOnChunkError(e?.message || e?.error?.message);
});
window.addEventListener("unhandledrejection", (e) => {
  maybeReloadOnChunkError(e?.reason?.message || e?.reason);
});

ReactDOM.render(
  // <React.StrictMode>
  <RouterImpl>
    <LoadingContextProvider>
      <AlertContextProvider>
        <DupLoginContextProvider>
          <App />
        </DupLoginContextProvider>
      </AlertContextProvider>
    </LoadingContextProvider>
  </RouterImpl>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
